import React, { useContext } from "react";
import { HandlerContext } from "components/lnb/LnbWrapper";
import { useSelector } from "react-redux";
import qs from "qs";

import imgThumbnail9 from "styles/common/img/common/more2.png";

function ListItem({ title, link, categoryType, info, drawCd }) {
    const contractNumber = useSelector((state) => state.loginReducer.contractNumber);
    const customerNumber = useSelector((state) => state.loginReducer.customerNumber);

    const handlerContext = useContext(HandlerContext);
    const isBadgeMenu = info?.MENU_CD === "BADGE";

    const gotoShortCutPage = () => {
        if (categoryType === "POP") {
            handlerContext.clickMenuTypeCodePOP(info, drawCd);
        } else if (categoryType === "POP_F") {
            handlerContext.clickMenuTypeCodePOPF(info, drawCd);
        } else if (categoryType === "LINK") {
            handlerContext.clickMenuTypeCodeLINK(info, drawCd);
        } else if (categoryType === "APP") {
            handlerContext.clickMenuTypeCodeAPP(info, drawCd);
        } else if (categoryType === "EXT_LINK") {
            handlerContext.clickMenuTypeCodeEXT_LINK(info, drawCd);
        }
    };

    const getBadgeUrl = () => {
        const badgeBaseUrl = link || info?.LINK || info?.MENU_URL;
        if (!badgeBaseUrl) return "";

        const OS_TYPE = localStorage.getItem("OS_TYPE") || "IOS";
        const query = qs.stringify({
            PGM_SCRN_TY: "POP_F",
            PGM_NAME: "나의 배지",
            memberCode: customerNumber,
            contractNumber: contractNumber,
            customerNumber: customerNumber,
            serviceName: "midBadge",
            deviceName: OS_TYPE,
            appPackage: "com.wjthinkbig.datacollectagent",
            appVersion: "0.1",
            imMid: "ios",
        });

        return `${badgeBaseUrl}${badgeBaseUrl.includes("?") ? "&" : "?"}${query}`;
    };
    const gotoBadge = () => {
        const badgeUrl = getBadgeUrl();
        if (!badgeUrl) return false;

        window.location.href = badgeUrl;
        return true;
    };

    const handleClickListItem = () => {
        if (isBadgeMenu && gotoBadge()) return;

        gotoShortCutPage();
    };

    return (
        <button className="shortCutlist fl" onClick={handleClickListItem}>
            <div className="shortCuttxt fl">{title}</div>
            <div className="shortCuticon fr">
                <img src={imgThumbnail9} alt="더보기" />
            </div>
        </button>
    );
}

export default ListItem;
